module.exports = __webpack_public_path__ + "df_font01.jpg?18ba9911575c878dc5bbdbbc2797e2e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/df_font01.jpg
// module id = 50
// module chunks = 0